export const SITES_AUTOCOMPLETE_LIMIT = 1000
